.lines {
  display: grid;
  gap: var(--space-3);
  padding-block-start: var(--space-2);
}
